import { render } from "./AdditionalRewardSettings.vue?vue&type=template&id=a8fb5dc4&ts=true"
import script from "./AdditionalRewardSettings.vue?vue&type=script&lang=ts"
export * from "./AdditionalRewardSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__